// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3lV8n","rootSmall":"AddTileButton_rootSmall__vnHeM"};